import { useState } from "react";
import { useRouter } from "next/router";
import { Box, Flex, Heading, useBreakpointValue } from "@chakra-ui/react";
import { getLayout } from "components/Layout";
import PageSection from "components/Layout/PageSection";
import HeadTitle from "components/Shared/HeadTitle";
import DocumentFolders from "components/Core/Documents/DocumentFolders";
import FolderDetails from "components/Core/Documents/FolderDetails";
import FolderDocuments from "components/Core/Documents/FolderDocuments";
import { CONTENT_FULL_HEIGHT } from "components/Layout/constants";
import FormFieldWrapperInline from "components/Shared/Forms/FormFieldWrapperInline";
import SwitchInput from "components/Shared/Forms/SwitchInput";

const SPACING = "3rem";

export default function DocumentsIndex() {
  const { query } = useRouter();
  const [isArchivedIncluded, setIsArchivedIncluded] = useState(false);

  const folderSlug = query?.folder as string | undefined;

  const shouldStackFolderDetails = useBreakpointValue({
    base: true,
    lg: false,
  });
  return (
    <PageSection paddingTop={[0, 0, 0]} paddingBottom={[0, 0, 0]}>
      <HeadTitle title="Document Library" />
      <Flex>
        <Box flex="1 1 100%" paddingTop={SPACING}>
          <Box
            paddingRight={{ base: 0, lg: SPACING }}
            paddingBottom={SPACING}
            borderColor="magenta.veryDark"
            borderBottomWidth={1}
          >
            <Heading as="h1" variant="section-header" marginBottom="2rem">
              Document Library
            </Heading>

            <DocumentFolders />
          </Box>
          {shouldStackFolderDetails && folderSlug && (
            <Box marginTop={4}>
              <FolderDetails slug={folderSlug} />
            </Box>
          )}

          <Box
            padding={{
              base: `${SPACING} 0`,
              lg: `${SPACING} ${SPACING} ${SPACING} 0`,
            }}
          >
            <Flex position="relative">
              <FormFieldWrapperInline
                label="Include archived?"
                labelProps={{
                  whiteSpace: "nowrap",
                  fontSize: "sm",
                  color: "gray.500",
                  mb: 0,
                  mr: 2,
                }}
                ml="auto"
                my={0}
                w="auto"
                alignItems="center"
                position="absolute"
                right={{ base: 0, lg: `calc(${SPACING} / -2)` }}
                bottom={`calc(-100% + ${SPACING} / 4)`}
                sx={{ ">*": { m: 0 } }}
              >
                <SwitchInput
                  value={isArchivedIncluded}
                  onChange={setIsArchivedIncluded}
                  size="md"
                />
              </FormFieldWrapperInline>
            </Flex>

            {folderSlug && (
              <FolderDocuments
                slug={folderSlug}
                isArchivedIncluded={isArchivedIncluded}
              />
            )}
          </Box>
        </Box>
        {!shouldStackFolderDetails && (
          <Flex
            flex="0 0 20rem"
            flexFlow="column"
            paddingLeft={SPACING}
            paddingTop={SPACING}
            minHeight={CONTENT_FULL_HEIGHT}
            borderColor="magenta.veryDark"
            borderLeftWidth={1}
          >
            {folderSlug && <FolderDetails slug={folderSlug} />}
          </Flex>
        )}
      </Flex>
    </PageSection>
  );
}

DocumentsIndex.getLayout = getLayout;
